import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobangloreurbania() {



    const cardData =
    {
        keyword: 'Pune to Bangalore Urbania Rental Service',
        heading: 'Urbania on rent in pune: Pune to Bangalore Urbania Rental Service',
        headingDescription: 'Urbania On Rent in Pune offers premium and reliable Pune to Bangalore Urbania Rental Service for corporate groups, families, tourists, and event travelers planning comfortable long-distance travel. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, ample luggage space, and smooth highway performance, making it ideal for business travel, family trips, weddings, airport transfers, and outstation journeys from Pune to Bangalore. With professional chauffeurs experienced in interstate routes, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for Pune to Bangalore Urbania rental services.',

        top: 'Top Places to Visit in Bangalore with Pune on rent in pune',


"topPlaces": [
  {
    "title": "Bangalore Palace",
    "description": "Bangalore Palace is one of the most iconic heritage landmarks of the city, inspired by England’s Windsor Castle. Built in 1887, the palace features Tudor-style architecture, fortified towers, elegant wood carvings, stained glass windows, and beautifully decorated interiors. The palace grounds often host cultural events, concerts, and exhibitions. A visit here offers a glimpse into the royal lifestyle of the Wodeyar dynasty and is perfect for history lovers and photographers."
  },
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden is a vast green oasis spread across 240 acres in the heart of Bangalore. It is home to thousands of plant species, rare tropical flora, and a stunning glasshouse inspired by London’s Crystal Palace. The garden is especially famous for its biannual flower shows. With serene walking paths, ancient trees, and scenic lakes, Lalbagh is ideal for nature lovers, morning walks, and peaceful relaxation."
  },
  {
    "title": "Cubbon Park",
    "description": "Cubbon Park is a beautifully landscaped urban park offering a refreshing escape from the city’s fast pace. Spread over 300 acres, it features lush greenery, walking tracks, statues, libraries, and colonial-era buildings nearby. The park is popular among joggers, cyclists, families, and photographers. Early mornings and evenings are especially pleasant, making it a perfect spot to unwind amid nature."
  },
  {
    "title": "ISKCON Temple Bangalore",
    "description": "ISKCON Temple Bangalore is one of the largest and most magnificent Krishna temples in the world. Located on Hare Krishna Hill, the temple combines modern architecture with traditional spiritual elements. The serene environment, devotional chants, and beautifully decorated deities create a peaceful atmosphere. The temple complex also offers cultural programs, vegetarian prasadam, and panoramic city views."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is an architectural masterpiece and the seat of the Karnataka State Legislature. Built in Neo-Dravidian style, it is one of the largest legislative buildings in India. The massive granite structure looks especially grand when illuminated at night. Although entry is restricted, viewing and photographing the exterior is a must for visitors interested in architecture and governance."
  },
  {
    "title": "Bannerghatta National Park",
    "description": "Bannerghatta National Park is a popular wildlife and eco-tourism destination located on the outskirts of Bangalore. It includes a biological park, zoo, butterfly park, and safari zones for lions, tigers, and bears. The park offers educational experiences, nature trails, and close encounters with wildlife, making it an ideal destination for families and nature enthusiasts."
  },
  {
    "title": "Nandi Hills",
    "description": "Nandi Hills is a scenic hill station located near Bangalore, famous for its breathtaking sunrise views and cool climate. The hilltop offers panoramic views of mist-covered valleys, ancient temples, and historical fortifications. It is a favorite weekend getaway for bikers, photographers, and nature lovers seeking peace and fresh air."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is one of Bangalore’s most popular shopping destinations, known for its vibrant atmosphere and wide variety of products. From trendy clothing and footwear to jewelry and accessories, the street offers options for all budgets. The lively lanes, street vendors, and bargaining culture make it a fun shopping experience for tourists."
  },
  {
    "title": "UB City Mall",
    "description": "UB City Mall is Bangalore’s premier luxury shopping and lifestyle destination. It features high-end international brands, fine-dining restaurants, art galleries, and stylish cafés. The beautifully designed plaza and vibrant nightlife make it a popular hangout spot for those seeking a modern and upscale city experience."
  },
  {
    "title": "Wonderla Amusement Park",
    "description": "Wonderla Amusement Park is one of India’s best-known theme parks, offering thrilling rides, water attractions, and entertainment for all age groups. Located near Bangalore, it features roller coasters, wave pools, kids’ zones, and live shows. It is a perfect destination for families, friends, and adventure seekers looking for a fun-filled day."
  }
],




"services": [
{
"name": "Pune to Bangalore Urbania Rental Service",
"description": "Pune to Bangalore Urbania Rental Service offers reliable and comfortable Urbania buses for long-distance travel between Pune and Bangalore. The service is ideal for families, corporate groups, and tourists, providing spacious seating, clean interiors, ample luggage space, and experienced drivers for a smooth interstate journey."
},
{
"name": "Bangalore Urbania Hire from Pune",
"description": "Bangalore Urbania Hire from Pune provides flexible Urbania bus rental options for one-way and round-trip travel. With well-maintained vehicles and professional chauffeurs, the service ensures punctual pickups, safe driving, and a relaxed travel experience."
},
{
"name": "Urbania Bus Rental Pune to Bangalore",
"description": "Urbania Bus Rental Pune to Bangalore features well-serviced buses designed for extended highway travel. The service focuses on passenger comfort, reliable performance, and safety throughout the Pune–Bangalore route."
},
{
"name": "Urbania AC Bus Pune to Bangalore",
"description": "Urbania AC Bus Pune to Bangalore provides fully air-conditioned Urbania buses for a comfortable and climate-controlled journey, making long hours on the road more pleasant for all travelers."
},
{
"name": "Pune Bangalore Urbania One Way Hire",
"description": "Pune Bangalore Urbania One Way Hire offers convenient one-way travel solutions for travelers moving from Pune to Bangalore, ensuring timely pickup, professional driving, and hassle-free transportation."
},
{
"name": "Pune Bangalore Urbania Round Trip Hire",
"description": "Pune Bangalore Urbania Round Trip Hire provides complete round-trip transportation with well-planned schedules, allowing travelers to focus on business or leisure without worrying about return travel arrangements."
},
{
"name": "Corporate Urbania Pune to Bangalore",
"description": "Corporate Urbania Pune to Bangalore offers organized and professional transport solutions for corporate teams, official tours, and business travel, emphasizing punctuality, comfort, and smooth coordination."
},
{
"name": "Family Tour Urbania Pune to Bangalore",
"description": "Family Tour Urbania Pune to Bangalore is designed to provide a safe, spacious, and comfortable travel environment for families, ensuring an enjoyable journey for all age groups."
},
{
"name": "Luxury Urbania Pune to Bangalore",
"description": "Luxury Urbania Pune to Bangalore delivers a premium travel experience with modern interiors, plush seating, and superior ride comfort, ideal for travelers seeking a refined and relaxed journey."
},
{
"name": "Affordable Urbania Pune to Bangalore",
"description": "Affordable Urbania Pune to Bangalore provides budget-friendly Urbania bus rental services without compromising on safety or comfort, making it suitable for cost-conscious travelers and group trips."
},
{
"name": "Chauffeur Driven Urbania Pune to Bangalore",
"description": "Chauffeur Driven Urbania Pune to Bangalore ensures a stress-free journey with trained, verified drivers experienced in long-distance and interstate routes."
},
{
"name": "Pune Bangalore Urbania Travel Service",
"description": "Pune Bangalore Urbania Travel Service offers dependable and well-managed transportation solutions, focusing on comfort, reliability, and customer satisfaction throughout the journey."
},
{
"name": "Best Urbania Hire Pune to Bangalore",
"description": "Best Urbania Hire Pune to Bangalore is known for quality vehicles, professional service, and consistent reliability, making it a preferred choice for Pune to Bangalore travel."
},
{
"name": "Outstation Urbania Hire Pune",
"description": "Outstation Urbania Hire Pune provides reliable Urbania bus rental services for travel from Pune to major cities and destinations, ensuring safe, comfortable, and well-coordinated outstation journeys."
},
{
"name": "Trusted Bangalore Urbania Service",
"description": "Trusted Bangalore Urbania Service delivers safe, dependable, and customer-focused Urbania bus rental services, ensuring a smooth and comfortable travel experience between Pune and Bangalore."
}
],
"tableData": [
["Pune to Bangalore Urbania Rental Service", "Bangalore Urbania Hire from Pune"],
["Urbania Bus Rental Pune to Bangalore", "Urbania AC Bus Pune to Bangalore"],
["Pune Bangalore Urbania One Way Hire", "Pune Bangalore Urbania Round Trip Hire"],
["Corporate Urbania Pune to Bangalore", "Family Tour Urbania Pune to Bangalore"],
["Luxury Urbania Pune to Bangalore", "Affordable Urbania Pune to Bangalore"],
["Chauffeur Driven Urbania Pune to Bangalore", "Pune Bangalore Urbania Travel Service"],
["Best Urbania Hire Pune to Bangalore", "Outstation Urbania Hire Pune"],
["Trusted Bangalore Urbania Service", ""]
],



whychoose : [
    {
        "WhyChooseheading": "Pune to Bangalore Urbania Rental Service for Comfortable Travel",
        "WhyChoosedescription": "Pune to Bangalore Urbania Rental Service is perfect for long-distance travel, family trips, group journeys, corporate tours, and leisure travel, offering a hassle-free and comfortable ride."
    },
    {
        "WhyChooseheading": "Spacious and Modern Urbania Buses",
        "WhyChoosedescription": "Our Urbania buses for Pune to Bangalore travel are equipped with air-conditioning, comfortable reclining seats, ample legroom, and sufficient luggage space for smooth long-distance journeys."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Interstate Travel",
        "WhyChoosedescription": "All drivers are trained and experienced in interstate travel from Pune to Bangalore, ensuring safe driving, punctual arrivals, and stress-free journeys."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Pune to Bangalore Urbania Rental Service offers competitive rates with no hidden charges, making long-distance travel cost-effective and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "We provide round-the-clock booking assistance and dedicated customer support for inquiries, reservations, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Travel Packages",
        "WhyChoosedescription": "Available for one-way trips, round trips, multi-day journeys, corporate travel, and customized itineraries as per your requirements."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania buses are regularly cleaned, sanitized, and well-maintained to ensure passenger comfort and hygiene throughout the journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Our Pune to Bangalore Urbania Rental Service guarantees on-time departures, dependable travel support, and a smooth overall experience."
    }
]
}
const faqData = [
    {
        question: 'Can Pune to Bangalore Urbania Rental Service be booked for long-distance travel?',
        answer: 'Yes, it is suitable for long-distance journeys, family trips, group travel, corporate tours, and interstate travel.'
    },
    {
        question: 'How can I book Pune to Bangalore Urbania Rental Service?',
        answer: 'Bookings can be made via phone, WhatsApp, or online for quick and convenient reservations.'
    },
    {
        question: 'Why choose Pune to Bangalore Urbania Rental Service?',
        answer: 'This service offers comfortable seating, professional drivers, clean vehicles, flexible travel plans, and transparent pricing.'
    },
    {
        question: 'Are drivers experienced for the Pune to Bangalore route?',
        answer: 'Yes, all drivers are licensed, trained, and experienced in interstate routes including Pune to Bangalore.'
    },
    {
        question: 'Can pickup and drop locations be customized?',
        answer: 'Absolutely. Flexible pickup and drop-off locations are available across Pune and nearby areas.'
    },
    {
        question: 'Is Pune to Bangalore Urbania Rental Service available 24/7?',
        answer: 'Yes, booking services and customer support are available 24/7.'
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are thoroughly cleaned, sanitized, and well-maintained for passenger safety.'
    },
    {
        question: 'What payment options are accepted?',
        answer: 'Payments can be made via UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing.'
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey.'
    },
    {
        question: 'Is this service suitable for families and corporate groups?',
        answer: 'Yes, Pune to Bangalore Urbania Rental Service is ideal for families, corporate groups, and large travel parties.'
    }
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Arjun Patil',
        feedback: 'The Pune to Bangalore trip was very comfortable. The Urbania bus was spacious, clean, and perfect for interstate travel.',
        rating: 5
    },
    {
        id: 2,
        name: 'Ms. Sneha Reddy',
        feedback: 'Professional service and experienced driver. Pune to Bangalore Urbania Rental Service made our journey smooth and enjoyable.',
        rating: 5
    }
];











































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bangalore Urbania Rental Service",
  "image": "https://urbaniaonrentpune.in/assets/images/pune-bangalore-urbania.jpg",
  "description": "Pune to Bangalore Urbania Rental Service offers AC Urbania buses for one-way or round-trip travel, corporate trips, family tours, pilgrimage journeys, and group travel. Chauffeur-driven Urbania buses ensure safe, comfortable, and convenient transportation from Pune to Bangalore.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/pune-to-bangalore-urbania-rental-service"
  }
};




    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Pune to Bangalore Urbania Rental Service | AC Urbania Bus One Way & Round Trip 
  </title>

  <meta
    name="description"
    content="Book Pune to Bangalore Urbania Rental Service for one-way or round-trip travel, corporate trips, family tours, pilgrimage journeys, and group travel. AC Urbania buses with chauffeur-driven service provide safe, comfortable, and convenient transportation from Pune to Bangalore."
  />

  <meta
    name="keywords"
    content="Pune to Bangalore Urbania Rental Service, Bangalore Urbania Hire from Pune, Urbania Bus Rental Pune to Bangalore, Urbania AC Bus Pune to Bangalore, Pune Bangalore Urbania One Way Hire, Pune Bangalore Urbania Round Trip Hire, Corporate Urbania Pune to Bangalore, Family Tour Urbania Pune to Bangalore, Luxury Urbania Pune to Bangalore, Affordable Urbania Pune to Bangalore, Chauffeur Driven Urbania Pune to Bangalore, Pune Bangalore Urbania Travel Service, Best Urbania Hire Pune to Bangalore, Outstation Urbania Hire Pune, Trusted Bangalore Urbania Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/89.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetobangloreurbania;